"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageIteratorApi = void 0;
var model_iterator_1 = require("../../core/model/model-iterator");
var images_1 = require("./images");
var ImageIteratorApi = (function () {
    function ImageIteratorApi(processor, subDocument, pos) {
        this._processor = processor;
        this._subDocument = subDocument;
        this._iterator = new model_iterator_1.ModelIterator(subDocument, true);
        this._iterator.setPosition(pos);
    }
    Object.defineProperty(ImageIteratorApi.prototype, "image", {
        get: function () {
            return this._currImage;
        },
        enumerable: false,
        configurable: true
    });
    ImageIteratorApi.prototype.next = function () {
        do {
            this._currImage = images_1.getImageApiFromRun(this._processor, this._subDocument, this._iterator);
            if (this._currImage) {
                this._iterator.moveToNextRun();
                return true;
            }
        } while (this._iterator.moveToNextRun());
        return false;
    };
    return ImageIteratorApi;
}());
exports.ImageIteratorApi = ImageIteratorApi;
